export default "__VITE_ASSET__2rzj1fMJ__"